import React from 'react';
import { Link } from 'react-router-dom';
import Imageone from "../../images/Power Tools/one.webp";
import Imagetwo from "../../images/Power Tools/two.webp";
import Imagethree from "../../images/Power Tools/three.webp";
import Imagefour from "../../images/Power Tools/four.webp";
import Imagefive from "../../images/Power Tools/five.webp";
import Imagesix from "../../images/Power Tools/six.webp";
import Imageseven from "../../images/Power Tools/seven.webp";
import Imageeight from "../../images/Power Tools/eight.webp";
import Imagenine from "../../images/Power Tools/nine.webp";
import Imageten from "../../images/Power Tools/ten.webp";
import Imageeleven from "../../images/Power Tools/eleven.webp";
import Imagetwelve from "../../images/Power Tools/twelve.webp";

const tools = [
  { img: Imageone, name: "Drills" },
  { img: Imagetwo, name: "Pneumatic Tools" },
  { img: Imagethree, name: "Angle Grinders" },
  { img: Imagefour, name: "Electric Screwdrivers" },
  { img: Imagefive, name: "Electric Saws" },
  { img: Imagesix, name: "Sanders" },
  { img: Imageseven, name: "Polishers" },
  { img: Imageeight, name: "Wood Router & Trimmer" },
  { img: Imagenine, name: "Nail Gun" },
  { img: Imageten, name: "Angle Grinder" },
  { img: Imageeleven, name: "Orbital Sander" },
  { img: Imagetwelve, name: "Impact Driver" },
];

function Coming() {
  return (
    <div className="py-6">
      <div className="bg-white rounded-xl">
        <div className="mx-auto py-10 sm:px-10 sm:py-14">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {tools.map((tool, index) => (
              <Link
                key={index}
                to="#"
                className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50"
              >
                <div className="relative">
                  <img
                    src={tool.img}
                    alt={tool.name}
                    className="w-full h-64 object-cover transition-opacity duration-300 rounded-t-2xl"
                  />
                  <div className="px-4 py-3 text-center">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                      {tool.name}
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Coming;
